<template>
  <div>
    <QrcodeVue v-if="value" :value="value" :size="size" level="H" />
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: { QrcodeVue },
  props: ["value", "size"],
  setup() {
    return {};
  },
};
</script>
